var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "title-row" },
    [
      _c("div", { staticClass: "left" }, [
        _c("img", {
          staticClass: "title-icon",
          style: { visibility: _vm.showIcon ? "visible" : "hidden" },
          attrs: { src: _vm.TitleIcon },
        }),
        _c("div", { staticClass: "title-text" }, [
          _vm.titleText
            ? _c("div", {
                staticClass: "text1",
                domProps: { innerHTML: _vm._s(_vm.titleTextHtml) },
              })
            : _vm._e(),
          _vm.subtitleText
            ? _c("div", { staticClass: "text2" }, [
                _vm._v(_vm._s(_vm.subtitleText)),
              ])
            : _vm._e(),
        ]),
      ]),
      _vm._t("comment"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }